export const AriaRoleType = {
  List: 'list',
  ListBox: 'listbox',
};

export const ItemAriaRoleType = {
  ListItem: 'listitem',
  ListBoxOption: 'option',
};

export const ItemAriaRoleConfig = {
  [AriaRoleType.List]: ItemAriaRoleType.ListItem,
  [AriaRoleType.ListBox]: ItemAriaRoleType.ListBoxOption,
};
